const Vue = require('vue')

Vue.component('form-radio', require('components/std/Radio.vue'))



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/radio.js